import {Component, OnInit,} from '@angular/core';
import {FormBuilder, FormGroup,} from '@angular/forms';
import {HttpClient,} from '@angular/common/http';
import {LoginUserVO,} from '@models/system-vo/login-user-vo';
import {MessageLevel,} from '@models/system-vo/message-level';
import {FileUtil,
        Logger,
        LoginInfoService,
        MessageProvider,
        MessageStackService,
        SmsMenuPage,
        SmsErrorPage,
        StringUtil,
        SystemConstant,
        ValidationService,} from '@services/index';
import {SMS006SeikyugakuInfoOutVO,} from '@pages/sms006-seikyugaku-info/sms006-seikyugaku-info-out-vo';
import * as Const_SMS006 from '@pages/sms006-seikyugaku-info/sms006-seikyugaku-info-const';
import {Title,} from '@angular/platform-browser';

@Component({
  selector: 'app-sms006-seikyugaku-info',
  templateUrl: './sms006-seikyugaku-info.html',
  styleUrls: ['./sms006-seikyugaku-info.scss',],
})
/*****************************************************/
/* 処　理：SMS006 請求金額確認 画面
/*
/* 概　要：翌月家賃等請求額確認 処理
/*
/* 更新日：2025/01/08 HARAGU 00011_SMS機能等の導入支援
/*****************************************************/
export class SMS006SeikyugakuInfo implements OnInit {
  smsForm!: FormGroup;                        // 画面フォーム
  loginUserVO!: LoginUserVO;                  // セッション情報
  sms006ApiRetVO!: SMS006SeikyugakuInfoOutVO; // API返却情報
  dispId!: string;                            // ログ表示用ID
  lngType!: string;                           //  言語区分

  // コンテンツエリア：style.width 設定用
  windowsWidth = this.constant.DEFAULT_DEVICE_SCREEN_WIDTH + 'px';

  // 画面項目（ラベル入れ替え用）
  public lblName!: string;
  public lblShutokuDate!: string;
  public lblMessage01!: string;
  public lblMessage02!: string
  public lblMessage03!: string;
  public lblBtnMenu!: string;
  public lblScreenName!: string;
  // 明細表示用
  public lblYatinYm!: string;
  public lblSeikyuGaku!: string;


  /**
   * デフォルトコンストラクタ
   */
  constructor(
    private constant: SystemConstant,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private logger: Logger,
    private messageProvider: MessageProvider,
    private titleService: Title,
    private smsMenuPage: SmsMenuPage,
    private smsErrPage: SmsErrorPage,
    public fileUtil: FileUtil,
    public loginInfoService: LoginInfoService,
    public stringUtil: StringUtil,
    public validationService: ValidationService
  ) {
    const connVo: LoginUserVO = this.loginInfoService.getLoginUserInfo();
    if (connVo && connVo.hashId != null && !this.stringUtil.isEmpty(connVo.hashId)
        && connVo.accessToken  != null && !this.stringUtil.isEmpty(connVo.accessToken)
        && connVo.refreshToken != null && !this.stringUtil.isEmpty(connVo.refreshToken)) {

      // ログイン情報を取得
      this.loginUserVO = connVo;

      // ログ表示用ID・言語区分セット
      this.dispId = this.loginUserVO.keiyakuInfoId.toString();
      this.lngType = this.loginUserVO.languageType;

    } else {

      // エラーログ出力
      this.logger.error('SMS00601M005E');

      // ログイン情報が取得出来ない場合、エラー画面へ遷移（予期せぬエラー）
      const messageStack = new MessageStackService(MessageLevel.ERROR);
      messageStack.add({messageId: 'SMS99901M013E',});
      this.smsErrPage.transition(messageStack, '', '', constant.DEFAULT_LANGUAGE_TYPE);
      return;
    }
  }

  /**
   * 初期処理(ngOnInit).
   */
  ngOnInit(): void {

    // 画面オブジェクト
    this.smsForm = this.fb.group({
    });

    // 初期表示
    this.formInit();
  }


  /* **************************************************************
   * 初期表示
   * **************************************************************/
  formInit(): void {
    try {
      // ログ出力
      this.logger.info('SMS00601M001I', this.dispId, Const_SMS006.INIT_NAME);

      // 初期表示API処理
      this.getInitData(Const_SMS006.API_INIT_PATH, Const_SMS006.INIT_NAME);

      // デバイスの横幅がデフォルト値未満の場合、横幅を調整する
      if (this.constant.DEFAULT_DEVICE_SCREEN_WIDTH > window.innerWidth) {
        this.logger.debug('■ content-area style.width:' + window.innerWidth);
        this.windowsWidth = window.innerWidth + 'px';
      }

      // ログ出力
      this.logger.info('SMS00601M002I', this.dispId, Const_SMS006.INIT_NAME);

    } catch (ex) {
      this.logger.error('SMS00601M001E', this.dispId, Const_SMS006.INIT_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 初期表示API処理
   * @param {string} path パスAPI
   * @param {string} btnName ボタン名
   */
  private getInitData(path: string, btnName: string): void {

    this.logger.debug(this.dispId + ' ■ 06 start-- getInitData');

    // APIパラメータ設定
    const apiVo = {
      keiyakuInfoId: this.loginUserVO.keiyakuInfoId,
      shouninNo: this.loginUserVO.shouninNo,
    }

    // ログ出力（API入力情報）
    this.logger.debug(this.dispId + ' ■ 06 URL：[' + path + ']');
    this.logger.debug(this.dispId + ' ■ 06 ApiIn   keiyakuInfoId：' + apiVo.keiyakuInfoId);
    this.logger.debug(this.dispId + ' ■ 06 ApiIn   shouninNo    ：' + apiVo.shouninNo);

    // 初期表示API
    this.logger.info('SMS00601M003I', this.dispId, btnName);
    this.httpClient.post<SMS006SeikyugakuInfoOutVO>(path, apiVo).subscribe({
      next: (resp) => {
        this.logger.info('SMS00601M004I', this.dispId, btnName);
        if (resp != null) {
          // 初期表示API 返却情報設定
          this.getInitApiReturnInfo(resp);

        } else {
          // エラー画面へ遷移（予期せぬエラー）
          this.logger.error('SMS00601M003E', this.dispId);
          const messageStack = new MessageStackService(MessageLevel.ERROR);
          messageStack.add({messageId: 'SMS99901M013E',});
          this.transitErrPage(messageStack);
        }
        return;
      },
      error: (err: MessageStackService | Error) => {
        // エラーログ
        this.logger.error('SMS00601M004E', this.dispId);

        // Errorの場合
        if (err instanceof Error) {
          // 共通例外処理
          this.commonException(err);
          return;
        }
        // MessageStackの場合
        if (err instanceof MessageStackService && err.messages.length > 0) {
          const messageStack: MessageStackService = new MessageStackService(MessageLevel.ERROR);
          for (const messageError of err.messages) {
            this.logger.debug(this.dispId + ' ■ 06 messageId ：' + messageError.messageId);
            this.logger.error(messageError.messageId);
            messageStack.add({messageId: messageError.messageId,});
          }
          // エラー画面へ遷移
          this.transitErrPage(messageStack);
          return;
        }
      },
    });
  }

  /**
   * 初期表示API 返却情報設定
   *
   * @param {SMS006SeikyugakuInfoOutVO} resp API返却情報
   * @returns -
   */
  getInitApiReturnInfo(resp: SMS006SeikyugakuInfoOutVO): void {

    this.logger.debug(this.dispId + ' ■ 06 start-- getInitApiReturnInfo');

    // ログ出力（API出力情報）
    this.logger.debug(this.dispId + ' ■ 06 ApiOut  yatinYm    ：' + resp['yatinYm']);
    this.logger.debug(this.dispId + ' ■ 06 ApiOut  seikyuGaku ：' + resp['seikyuGaku']);

    // 家賃年月
    const yy = resp['yatinYm'].substring(0, 4);
    const mm = resp['yatinYm'].substring(4, 6);

    // 画面文言（言語区分により変換）
    // {1}　{2} 様
    this.lblName = (this.messageProvider.getMessageString({messageId: 'SMS006' + this.lngType + 'M001F',},  false) || '').replace('{1}', resp['sei']).replace('{2}', resp['mei']);
    // オリコフォレントインシュアでございます。
    this.lblMessage01 = this.messageProvider.getMessageString({messageId: 'SMS006' + this.lngType + 'M002F',},  false) || '';
    // 【{1}月分請求額】
    this.lblMessage02 = (this.messageProvider.getMessageString({messageId: 'SMS006' + this.lngType + 'M003F',},  false) || '').replace('{1}', mm).replace('{2}', yy);
    // {1}年{2}月
    this.lblYatinYm = (this.messageProvider.getMessageString({messageId: 'SMS006' + this.lngType + 'M004F',},  false) || '').replace('{1}', yy).replace('{2}', mm);
    // {1} 円
    this.lblSeikyuGaku = (this.messageProvider.getMessageString({messageId: 'SMS006' + this.lngType + 'M005F',},  false) || '').replace('{1}', resp['seikyuGaku']);

    // 取得日付
    const sYy = resp['shutokuDate'].substring(0, 4);
    const sMm = resp['shutokuDate'].substring(4, 6);
    const sDd = resp['shutokuDate'].substring(6, 8);

    //'（{1}年{2}月{3}日時点）
    this.lblShutokuDate = (this.messageProvider.getMessageString({messageId: 'SMS006' + this.lngType + 'M006F',},  false) || '').replace('{1}', sYy).replace('{2}', sMm).replace('{3}', sDd);
    // になります。
    this.lblMessage03 = this.messageProvider.getMessageString({messageId: 'SMS006' + this.lngType + 'M007F',},  false) || '';
    // メニューへ戻る
    this.lblBtnMenu = this.messageProvider.getMessageString({messageId: 'SMS006' + this.lngType + 'M008F',},  false) || '';

    // ブラウザ・ヘッダータイトル
    const screenName = this.messageProvider.getMessageString({messageId: 'SMS006' + this.lngType + 'M001T',}) || '';
    const companyName = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M001T',}) || '';
    this.titleService.setTitle(screenName + ' | ' + companyName);
    document.getElementById('lblScreenTitle')!.innerText = screenName;

    this.logger.debug(this.dispId + ' ■ 06 end---- getInitApiReturnInfo');
    return;
  }

  /* **************************************************************
   * メニューへ戻るボタン押下
   * **************************************************************/
  backClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00601M005I', this.dispId, Const_SMS006.BTN_BACKMENU_NAME);

      // SMS001：メインメニュー画面に遷移
      this.smsMenuPage.transition(this.loginUserVO.hashId,
                                  this.loginUserVO.menuNo,
                                  this.loginUserVO.languageType);

    } catch (ex) {
      this.logger.error('SMS00601M002E', this.dispId, Const_SMS006.BTN_BACKMENU_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 共通例外処理
   * @param {Error} err
   */
  private commonException(err?: Error | unknown): void {

    this.logger.debug(this.dispId + ' ■ 06 共通例外処理開始');

    // エラーログ
    if (err instanceof Error) {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err.message, this.dispId);
    } else {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err, this.dispId);
    }

    // エラー画面へ遷移（予期せぬエラー）
    const messageStack = new MessageStackService(MessageLevel.ERROR);
    messageStack.add({messageId: 'SMS99901M013E',});
    this.transitErrPage(messageStack);
  }

  /**
   * エラー画面へ遷移
   * @param {MessageStackService} messageStack
   */
  transitErrPage(messageStack: MessageStackService): void {

    // SMS011：エラー画面に遷移
    this.smsErrPage.transition(messageStack,
                               this.loginUserVO.hashId,
                               this.loginUserVO.menuNo,
                               this.loginUserVO.languageType);
  }

}
